<template>
    <a-config-provider
        :locale="locale === 'en' ? enUS : zhCN"
        :theme="{
            token: {
                colorPrimary: state.themeColor,
            },
        }">
        <RouterView />
    </a-config-provider>
</template>
<script setup>
import { defineAsyncComponent, reactive, onMounted } from "vue";
import enUS from 'ant-design-vue/es/locale/en_US';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/zh-cn';


// 获取i18n;
const route = useRoute();

const state = reactive({
    themeColor: "#139292",
    themeActiveColor: "#167474",
    locale:'cn',
});

let dayjsLang = {
    cn : 'zh-cn',
    en : 'en-us',
}

watch(() => route.params,(newValue, oldValue) =>{
    state.locale = newValue.lang;
    dayjs.locale(dayjsLang[newValue.lang]);
},{
    immediate: true,
})

const setSkinFun = () => {
  document
        .getElementsByTagName("html")[0]
        .style.setProperty("--theme-color", state.themeColor);
    document
        .getElementsByTagName("html")[0]
        .style.setProperty("--theme-active-color", state.themeActiveColor);
}

onMounted(() => {
    setSkinFun();
  
});
</script>

<style lang="less">
html,body{
    margin:0;
    padding:0;
    word-wrap: break-word;
}
#app{
    font-size:14px;
    word-break: break-word;
}
.ant-spin{
    min-height:100px;
    width:100%;
}

.ant-card{
    border-radius: 5px;
    &-head{
        background-color: #fafafa!important;
        min-height:50px!important;
    }
}

// 自定义弹框高度
.modal-content{
    max-height:70vh;
    min-height:200px;
    overflow-y: auto;
    overflow-x:hidden;
}

@media screen and (max-width:768px){

    // 弹窗moda l样式
    .ant-modal{
        &-content{
            padding:15px!important;
        }
    }
}
</style>
